"use client";

import {
  isServer,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { createContext, ReactNode } from "react";

export interface RootContextType {
  apiURLBase: string;
}

export const defaultRootContext: RootContextType = {
  apiURLBase: "",
};

export const RootContext = createContext(defaultRootContext);

let browserQueryClient: QueryClient | undefined;

export function RootContextProvider({
  initialState = defaultRootContext,
  children,
}: {
  initialState: Partial<RootContextType>;
  children: ReactNode;
}) {
  const queryClient = (() => {
    if (isServer) {
      return new QueryClient();
    }

    if (!browserQueryClient) {
      browserQueryClient = new QueryClient();
    }

    return browserQueryClient;
  })();

  return (
    <RootContext.Provider
      value={{
        ...defaultRootContext,
        ...initialState,
      }}
    >
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </RootContext.Provider>
  );
}
